import dayjs from "dayjs";

import { percentageSignFilter } from "app/filters/ngFilters";
import { IndustryDataAvailability } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";
import { default as DurationService } from "app/services/DurationService";

import { SwitcherOption } from "../../shared/ShareTypeSwitcher";

// Compare mode empty state height calculation constants
const COMPARE_ROW_HEADER_HEIGHT = 32;
const COMPARE_ROW_HEIGHT = 41;
const PADDING = 25;

export const calculateCompareEmptyStateHeight = (competitorCount: number): number => {
    return COMPARE_ROW_HEADER_HEIGHT + competitorCount * COMPARE_ROW_HEIGHT - PADDING;
};

export const getShareValueBySwitcherOption = <T>(
    option: SwitcherOption,
    spendShare: T,
    impressionsShare: T,
    visitsShare: T,
): T => {
    switch (option) {
        case SwitcherOption.Spend:
            return spendShare;
        case SwitcherOption.Impressions:
            return impressionsShare;
        case SwitcherOption.Visits:
            return visitsShare;
    }
};

// Percentages are fractions (0..1) and always render with both decimals, so a value
// below 0.01% would round to a misleading "0.00%" — label it as sub-threshold instead.
const PERCENT_FRACTION_DIGITS = 2;
const MIN_DISPLAYED_PERCENT = 0.0001;
const BELOW_MIN_PERCENT_LABEL = "<0.01%";

export const formatPercentValue = (value: number): string => {
    if (value !== 0 && Math.abs(value) < MIN_DISPLAYED_PERCENT) {
        return BELOW_MIN_PERCENT_LABEL;
    }
    return `${(value * 100).toLocaleString(undefined, {
        minimumFractionDigits: PERCENT_FRACTION_DIGITS,
        maximumFractionDigits: PERCENT_FRACTION_DIGITS,
    })}%`;
};

export function isRequestedDateBeforeMay2025(durationString: string): boolean {
    try {
        const { iso } = DurationService.getDurationData(durationString).forAPI;
        return dayjs(iso.from).isBefore(dayjs(IndustryDataAvailability.MAY_2025, "YYYY-MM-DD"), "day");
    } catch (_error) {
        return false;
    }
}
